import { useEffect, useRef, type ReactNode } from 'react';

export function Modal({
  children,
  label,
  close,
}: {
  children: ReactNode;
  label: string;
  close: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    const element = dialog.current!;
    const previousFocus = document.activeElement as HTMLElement | null;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    element.showModal();
    const backdropClick = (event: MouseEvent) => {
      if (event.target === element) closeRef.current();
    };
    element.addEventListener('click', backdropClick);
    return () => {
      element.removeEventListener('click', backdropClick);
      element.close();
      document.body.style.overflow = overflow;
      previousFocus?.focus();
    };
  }, []);
  return (
    <dialog
      className="rd-dialog"
      ref={dialog}
      aria-label={label}
      onCancel={(event) => {
        event.preventDefault();
        close();
      }}
    >
      <div className="rd-dialog-inner">
        <button
          className="rd-dialog-close"
          aria-label="Close dialog"
          onClick={close}
        >
          ×
        </button>
        {children}
      </div>
    </dialog>
  );
}
